import React from 'react';

import i_close from '../../UI/Close.png';
import i_close_black from '../../UI/Close_black.png';


import i_back from '../../UI/back_simple.png';





class CotizacionComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            
            statusGaleria: 'not rendered',
            sent: false
            
        };
    }

    componentDidMount(){
        // this.setState({statusGaleria:'loading'});
    }


    handleImageLoaded = () => {
        // console.log('hey si, ya cargue')
        // this.setState({ statusGaleria: "loaded" });
    }

    handleSubmit = (event) =>
    {
        //289        no me actualice la pagina!!
        event.preventDefault();
        const {handleSendFormCotizacion} = this.props;

        this.setState({sent: true})
        handleSendFormCotizacion(event);

    }

    hideConfirmation = () =>
    {
        this.setState({sent: false})
    }



    render()
    {

        let {sent} = this.state;
        let {tiposAptosCotizados , 
            handleCerrarCotizacion, handleUnselectAptoTipo, handleSendFormCotizacion, 
            aptosCotizados, handleUnselectApto } = this.props;
        

        return (

            <div>
                {!sent ?
                <div className="div-cotiza">
                    <div className="div-cotiza-header">
                        <h2>Cotiza</h2>
                        <button onClick={handleCerrarCotizacion}> <img src={i_close_black}/></button>
                    </div>
                    <hr></hr>
                    <div className="div-aptos-selected">
                        <h2>Tipo seleccionado</h2>
                        <p>Agrega el apartamento (max. 1) del proyecto que deseas cotizar.</p>


                        {/* <div className="btn-apto-selected">
                            <span> Apto Tipo A1-1</span>
                            <button onClick={() => handleUnselectAptoTipo({nombreAptoTipo:"Apto Tipo A1-1"})}> <img src={i_close}/></button>
                        </div> */}

                        {
                            aptosCotizados[0] &&
                            aptosCotizados.map( (a, i) => 
                                <div className="btn-apto-selected">
                                    <span> {a.TipoApto} {a.Numero}</span>
                                    <button onClick={() => handleUnselectApto({nombreAptoTipo:a.TipoApto, index:i, numeroApto:a.Numero })}> <img src={i_close_black}/></button>
                                </div>
                            )
                        }


                    </div>
                    <hr></hr>
                    <div className="div-cotiza-form">
                        <h2>Formulario</h2>
                        <form onSubmit = { (event) => this.handleSubmit(event) }>

                            <div>
                                <label className = "form-label">Nombres y apellidos*  </label>
                                <input name="textName" placeholder = "Nombre completos" type = "text" required></input>
                            </div><div>
                                <label className = "form-label">Correo electrónico*  </label>
                                <input name="textEmail" placeholder = "tu.correo@mail.com" type = "text" required></input>
                            </div><div>
                                <label className = "form-label">Teléfono*  </label>
                                <input name="textPhone" placeholder = "3123347566" type = "text" required></input>
                            </div>
                            
                            <div className="div-politica-datos">
                                <div className="check">
                                    <input type="checkbox" name="dataAccept" value="data-accepted" required/>
                                    <p>Acepto políticas para el tratamiento de datos personales</p>
                                </div>
                                <p>Bienes y Bienes recolectará y procesará sus datos personales de acuerdo con los lineamientos que se exponen 
                                    en esta <a target="_blank" href="https://bienesybienes.com/portal/politica-de-tratamiento-de-datos/">declaración de privacidad.</a></p> 
                            </div>
                                
                            <button className = "btn-cotiza"  type="submit">Enviar</button>
                        </form> 
                    </div> 

                    {/* {sent ?
                        <div className="aviso-sent">
                            <p>Te hemos enviado la información de los apartamentos a tu correo.</p>
                            <button className="btn-cotiza" onClick={(event) => this.hideConfirmation()}>Aceptar</button>
                        </div>
                        :<div></div>
                    }  */}

                </div>
                : 
                <div className="div-cotiza sent">
                    <div className="div-cotiza-header">
                        <h2>Cotiza</h2>
                        <button onClick={handleCerrarCotizacion}> <img src={i_close_black}/></button>
                    </div>
                    <hr></hr>

                    <div class="div-sent">
                        <div id="tick-mark"></div>
                        <h2>¡Gracias!</h2>
                        <p>Pronto recibirás un correo con tu cotización.</p>
                    </div>

                </div>
                }
            </div>
       
               
                
            

        );
    }
}

export default CotizacionComponent;